<template>
  <div class="selectIcon-tab">
    <div class="selectIcon-left fa fa-caret-left"></div>
    <div class="c-icon-blue fz-30 ovf-hd">
      <div v-for="item in icons" class="w-30 h-30 pointer fl selectIcon-margin m-b-10" :class="item.name" @click="selectIcon(item.name)"></div>
    </div>
  </div>
</template>

<style scoped>
.selectIcon-margin {
  margin-left: 20px;
}
.selectIcon-margin:first-child {
  margin-left: 0px; 
}
.selectIcon-tab {
  position: absolute;
  top: -10px;
  left: 115px;
	width: 530px;
  background: #fff;
  padding: 10px;
}
.selectIcon-left {
  position: absolute;
  left: -14px;
  top: 0px;
  color: #fff;
  font-size: 40px
}
</style>

<script>
  export default {
    name: 'selectIcon',
    data() {
      return {
        icons: [{
          name: 'icon-finance'
        }, {
          name: 'icon-legal'
        }, {
          name: 'icon-office'
        }, {
          name: 'icon-package'
        }, {
          name: 'icon-personnel'
        },{
          name: 'icon-project'
        },{
          name: 'icon-referral'
        },{
          name: 'icon-replenish'
        },{
          name: 'icon-statement'
        },{
          name: 'icon-supplier'
        },{
          name: 'icon-tender'
        }]
      }
    },
    methods: {
      selectIcon(val) {
        this.$emit('selectOneIcon', val)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// selectIcon.vue?359f3916